import axiosInstance from "@/services/AxiosTokenInstance";
import { i18n } from "@/i18n";

export async function fetchTranslations(isocode) {
  try {
    const response = await axiosInstance.get(`translations/print/${isocode}`);
    i18n.global.setLocaleMessage(isocode, response.data);
    if (typeof i18n.global.locale === "string") {
      i18n.global.locale = isocode;
    } else {
      i18n.global.locale.value = isocode;
    }
    document.documentElement.lang = isocode;
  } catch (error) {
    console.error(error);
  }
}

export function useTranslation() {
  return { fetchTranslations };
}
